import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'
import { mute } from '../action_x.js'
import { getName } from '../gallery.js'
import { ctrlButton } from '../ui.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { ownerDocument, name } = button
    let unmute = null
    let video = null
    let cameraBlock = null
    let videoName = null

    if (name) {
      video = one(`[id=${name.replace('mute_', '')}]`, ownerDocument)
      cameraBlock = video.closest(`.${elements.meet_camera}`)
      videoName = getName(video)
    }

    if (cameraBlock) { /* c'est un participant */
      mute(videoName)
    } else { /* c'est notre propre micro */
      button.classList.add(utilities.modifiers.display.none)
      unmute = ctrlButton('unmute', button.closest(`.${elements.meet_controls}`))
      unmute.classList.remove(utilities.modifiers.display.none)
      mute()
    }
  }
})

export default button => {
  onClick.listen(button)
}